import React from 'react';

const User = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M19 10.5C19 8.84315 17.6569 7.5 16 7.5C14.3431 7.5 13 8.84315 13 10.5C13 12.1569 14.3431 13.5 16 13.5C17.6569 13.5 19 12.1569 19 10.5ZM21 10.5C21 13.2614 18.7614 15.5 16 15.5C13.2386 15.5 11 13.2614 11 10.5C11 7.73858 13.2386 5.5 16 5.5C18.7614 5.5 21 7.73858 21 10.5ZM12.8891 17.2438L15.0061 17.7399C15.6479 17.8904 16.317 17.8798 16.9538 17.7093L18.5046 17.2939C19.3006 17.0807 20.1369 17.0675 20.9392 17.2555L21.141 17.3028C23.4016 17.8326 25 19.849 25 22.1709V24C25 25.6569 23.6569 27 22 27H10C8.34315 27 7 25.6569 7 24V21.9122C7 19.7419 8.45785 17.8421 10.5543 17.2806C11.3177 17.0761 12.1197 17.0635 12.8891 17.2438ZM11.0718 19.2125C9.84977 19.5398 9 20.6471 9 21.9122V24C9 24.5523 9.44772 25 10 25H22C22.5523 25 23 24.5523 23 24V22.1709C23 20.7778 22.0409 19.5679 20.6846 19.25L20.4828 19.2028C20.0015 19.0899 19.4997 19.0978 19.0221 19.2258L17.4712 19.6412C16.5161 19.897 15.5124 19.9128 14.5497 19.6872L12.4327 19.191C11.9842 19.0859 11.5167 19.0933 11.0718 19.2125Z" />
  </svg>
);

export default User;
